var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KioskCenteredLayout",
    { class: _vm.$style.container, attrs: { "full-height": "" } },
    [
      _c("div", { class: _vm.$style.confirmWrapper }, [
        _c(
          "div",
          { class: _vm.$style.confirmText },
          [_c("KioskMessageTitle", { attrs: { title: _vm.title } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$style.confirmButtons },
          [
            _c(
              "BaseButton",
              {
                class: _vm.$style.noBtn,
                attrs: { "button-style": "Back" },
                on: { click: _vm.handleCancel }
              },
              [_vm._v("\n        " + _vm._s(_vm.cancelText) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "BaseButton",
              {
                class: _vm.$style.yesBtn,
                attrs: { "button-style": "Main" },
                on: { click: _vm.handleConfirm }
              },
              [_vm._v("\n        " + _vm._s(_vm.confirmText) + "\n      ")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskConfirmMessage.vue?vue&type=template&id=8c92569e&
// module id = null
// module chunks = 